import { createContext } from 'react';

export const CheckoutContext = createContext<GQL.CheckoutOpen | GQL.CheckoutUpdate | null>(null);
export const CheckoutSetContext = createContext<React.Dispatch<React.SetStateAction<GQL.CheckoutOpen | GQL.CheckoutUpdate | null>>|null>(null);
export const ColorModeContext = createContext({ toggleColorMode: () => {} });